(function($){
  let iconBase = App.mediaPath+'icons/';
  //let iconBase = 'media/icons/';

  // Initialize and add the map
  function initDestinationMap () {
    let mapCenterPosition = {lat: 45.292969, lng: 12.308949 };
    // Destination, lat, lng, icon state, possible destination indexes, ID
    // Venezia contains possible destinations of 1,2,3,4 and 5 index
    // This city names should match with names under select element inside modal
    let locations = [
      ['Venice', 45.402336, 12.360621, 'active', [1, 2, 3, 4, 5], 0],
      ['Piran', 45.522300, 13.572333, 'inactive', [0], 1],
      //['Umag', 45.436724, 13.526064, 'inactive', [0], 2],
      ['Porec', 45.222572, 13.597139, 'inactive', [0], 3],
      ['Rovinj', 45.080948, 13.639890, 'inactive', [0], 4],
      ['Pula', 44.866259, 13.850704, 'inactive', [0], 5]
    ];

    let map = new google.maps.Map(document.getElementById('destinationsMap'), {
      zoom: 9,
      center: mapCenterPosition,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      draggable: false,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    let infowindow = new google.maps.InfoWindow();

    let marker, i;
    let markers = [];

    for (i = 0; i < locations.length; i++) {
      marker = new google.maps.Marker({
        id: i,
        position: new google.maps.LatLng(locations[i][1], locations[i][2]),
        map: map,
        clickable: true,
        icon: iconBase + 'google-marker-' + locations[i][3] + '.svg',
        animation: google.maps.Animation.DROP,
      });
      markers.push(marker);

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          for (let j = 0; j < markers.length; j++) {
            markers[j].setIcon(iconBase + 'google-marker-inactive.svg');
            // If current marker is inside array of possible destinations, make it visible, else hide it
            //markers[j].setVisible(locations[i][4].includes(markers[j].id));
          }

          //this.setVisible(true);
          this.setIcon(iconBase + 'google-marker-active.svg');
          infowindow.setContent('<button class="o-map__infowindow js-iw">' + locations[i][0] + '</button>');
          infowindow.open(map, marker);

          DestinationsPage.toggleActiveLocation(locations[i][0]);
        }
      })(marker, i));
      
      if (i > 0) {
        // Define a symbol using SVG path notation, with an opacity of 1.
        // const lineSymbol = {
        //   path: "M 0,-1 0,1",
        //   strokeOpacity: 1,
        //   scale: 4,
        // };
        //
        // new google.maps.Polyline({
        //   path: [
        //     { lat: locations[0][1], lng: locations[0][2] },
        //     { lat: locations[i][1], lng: locations[i][2] }
        //   ],
        //   geodesic: true,
        //   strokeColor: "#547FD8",
        //   strokeOpacity: 0,
        //   icons: [
        //     {
        //       icon: lineSymbol,
        //       offset: "0",
        //       repeat: "20px",
        //     },
        //   ],
        //   map: map
        // });
      }
    }

    infowindow.setContent('<button class="o-map__infowindow js-iw">' + locations[0][0] + '</button>');
    infowindow.open(map, markers[0]);
    setTimeout(function () {
      DestinationsPage.bindDestinationModals();
    }, 300);
    
    $('.js-marker-control').on('click', function () {
      let $self = $(this);
      let activeIindex = parseInt($self.val());
      let $otherButton = $self.siblings('.js-marker-control');
      let activeOtherIindex = parseInt($otherButton.val());
      let isPrev = $self.data('type') === 'prev' ? true : false;
      let max = locations.length - 1;
      let min = 0;
      let newThisIndex;
      let newOtherIndex;
      
      if (isPrev) {
        newThisIndex = activeIindex === min ? max : (activeIindex - 1);
        newOtherIndex = activeOtherIindex === min ? max : (activeOtherIindex - 1);
      } else {
        newThisIndex = activeIindex === max ? min : (activeIindex + 1);
        newOtherIndex = activeOtherIindex === max ? min : (activeOtherIindex + 1);
      }

      // new google.maps.event.trigger(markers[activeIindex], 'click' );

      infowindow.close();
      infowindow.setContent('<button class="o-map__infowindow js-iw">' + locations[activeIindex][0] + '</button>');
      new google.maps.event.trigger(markers[activeIindex], 'click');
      $self.val(newThisIndex);
      $otherButton.val(newOtherIndex);
      DestinationsPage.toggleActiveLocation(locations[activeIindex][0]);
    });
  }

  // Initialize and add the map
  function initCityPageMap () {
    let el = document.getElementById('cityPageMap');
    let cityPageMapCenterPosition = {lat: parseFloat(el.dataset.lat), lng: parseFloat(el.dataset.lng) };

    let cityPageMap = new google.maps.Map(el, {
      zoom: 15,
      center: cityPageMapCenterPosition,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      //draggable: false,
      //zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    new google.maps.Marker({
      position: cityPageMapCenterPosition,
      map: cityPageMap,
      icon: iconBase + 'google-marker-active.svg',
      animation: google.maps.Animation.DROP,
    });
  }

  // Initialize and add the map
  function initContactPageCroatiaMap () {
    let contactPageCroatiaMapCenterPosition = {lat: 45.227245, lng: 13.596915 };

    let contactPageCroatiaMap = new google.maps.Map(document.getElementById('contactPageMapCroatia'), {
      zoom: 15,
      center: contactPageCroatiaMapCenterPosition,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      //draggable: false,
      //zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    new google.maps.Marker({
      position: contactPageCroatiaMapCenterPosition,
      map: contactPageCroatiaMap,
      icon: iconBase + 'google-marker-active.svg',
      animation: google.maps.Animation.DROP,
    });
  }

  // Initialize and add the map
  function initContactPageItalyMap () {
    let contactPageItalyMapCenterPosition = {lat: 45.430579, lng: 12.320841 };

    let contactPageItalyMap = new google.maps.Map(document.getElementById('contactPageMapItaly'), {
      zoom: 15,
      center: contactPageItalyMapCenterPosition,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      //draggable: false,
      //zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

    new google.maps.Marker({
      position: contactPageItalyMapCenterPosition,
      map: contactPageItalyMap,
      icon: iconBase + 'google-marker-active.svg',
      animation: google.maps.Animation.DROP,
    });
  }

  // Initialize and add the map
  function initBookingConfirmPortMap () {
    $('.js-booking-port-map').each(function() {
      let $this = $(this);
      let lat = parseFloat($this.data('lat'));
      let lng = parseFloat($this.data('lng'));

      if (!lat || !lng) return;

      let center = {lat: lat, lng: lng };

      let map = new google.maps.Map(document.getElementById(this.id), {
        zoom: 15,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        draggable: false,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
      });

      new google.maps.Marker({
        position: center,
        map: map,
        icon: iconBase + 'google-marker-active.svg',
        animation: google.maps.Animation.DROP,
      });
    });
  }

  // Initialize and add the map
  //function initbookingPickupMap () {
  //  let locations = [
  //    ['Venice', 45.402336, 12.360621, 0],
  //    ['Piran', 45.522300, 13.572333, 1],
  //    ['Pula', 44.866259, 13.850704, 2]
  //  ];
//
  //  let mapCenterPosition = {lat: 45.292969, lng: 12.308949 };
  //  let bookingPickupMap = new google.maps.Map(document.getElementById('bookingPickupMap'), {
  //    zoom: 8,
  //    center: mapCenterPosition,
  //    mapTypeId: google.maps.MapTypeId.ROADMAP,
  //    draggable: false,
  //    zoomControl: false,
  //    mapTypeControl: false,
  //    scaleControl: false,
  //    streetViewControl: false,
  //    rotateControl: false,
  //    fullscreenControl: false
  //  });
//
  //  let marker, i;
  //  let markers = [];
//
  //  for (i = 0; i < locations.length; i++) {
  //    marker = new google.maps.Marker({
  //      id: i,
  //      position: new google.maps.LatLng(locations[i][1], locations[i][2]),
  //      map: bookingPickupMap,
  //      clickable: true,
  //      icon: iconBase + 'google-marker-inactive.svg',
  //      animation: google.maps.Animation.DROP,
  //    });
  //    markers.push(marker);
//
  //    google.maps.event.addListener(marker, 'click', (function(marker, i) {
  //      return function() {
  //        for (let j = 0; j < markers.length; j++) {
  //          markers[j].setIcon(iconBase + 'google-marker-inactive.svg');
  //        }
//
  //        this.setVisible(true);
  //        this.setIcon(iconBase + 'google-marker-active.svg');
  //        
  //        Booking.selectTicketByPickupLocation(locations[i][0]);
  //      }
  //    })(marker, i));
  //  }
  //  
  //  $('.js-ticket').on('click', function () {
  //    let location = $(this).data('pickup-location');
  //    
  //    for (let j = 0; j < markers.length; j++) {
  //      if (locations[j][0] === location) {
  //        markers[j].setIcon(iconBase + 'google-marker-active.svg');
  //      } else {
  //        markers[j].setIcon(iconBase + 'google-marker-inactive.svg');
  //      }
  //      
  //    }
  //  });
  //}

  $(document).ready(function () {
    if ($('#destinationsMap').length) {
      initDestinationMap();
    }

    if ($('#cityPageMap').length) {
      initCityPageMap();
    }
    
    if ($('#contactPageMapCroatia').length) {
      initContactPageCroatiaMap();
    }

    if ($('#contactPageMapItaly').length) {
      initContactPageItalyMap();
    }

    if ($('.js-booking-port-map').length) {
      initBookingConfirmPortMap();
    }

    //if ($('#bookingPickupMap').length) {
    //  initbookingPickupMap();
    //}
  });
})(jQuery)